import type { Store } from 'redux';
import type { Epic } from 'redux-observable';
import initializer from '@atlassian/jira-common-tangerine/src/state/initiate.tsx';
import famaErrorHandlerReduxMiddleware from '@atlassian/jira-errors-handling/src/utils/fama-redux-middleware.tsx';
import avatarService from '@atlassian/jira-project-settings-apps-common/src/avatar-service/avatar.tsx';
import { PACKAGE_NAME } from '../model/constants.tsx';
import type { AppProps } from '../model/types.tsx';
import type { Action } from './actions.tsx';
import rootReducer, { defaultState } from './reducer.tsx';
import type { State } from './types.tsx';

const errorMiddleware = famaErrorHandlerReduxMiddleware({
	packageName: PACKAGE_NAME,
	id: 'redux',
	sendToPrivacyUnsafeSplunk: true,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (rootEpic: Epic<Action, State>, appProps: AppProps): Store<State> =>
	initializer({
		appName: 'project-settings/issue-type-avatar-modal',
		rootReducer,
		rootEpic,
		rootEpicDependencies: { avatarService },
		initialState: {
			...defaultState,
			appProps,
		},
		middlewares: [errorMiddleware],
	});
